import { SceneName } from "../constants";
import TurnBasedInputPlugin from "../plugins/TurnBasedInputPlugin";
import { StarParticles } from "../art/FX/starsBackground";
import { SoundPlayer, MusicOptions } from "../sounds/SoundPlayer";

function sendStartEvent() {
  // Google analytics
  if (typeof window.ga === "function") {
    window.ga("send", "event", "TitleScene", "loadedGame");
  }
}

export default class TitleScene extends Phaser.Scene {
  private isTransitioning: boolean;
  private text: Phaser.GameObjects.Text;
  private fog: Phaser.GameObjects.TileSprite;
  private fog2: Phaser.GameObjects.TileSprite;
  private fog3: Phaser.GameObjects.TileSprite;
  private rikoText: Phaser.GameObjects.Sprite;
  constructor() {
    super(SceneName.TitleScene);
  }

  transitionToMap() {
    if (this.isTransitioning) {
      return;
    }
    SoundPlayer.clickSFX(this);
    SoundPlayer.titleStartSFX(this);
    this.add.tween({
      targets: this.rikoText,
      y: `-=20`,
      duration: 2000,
      ease: `Sine.easeIn`,
    });
    this.isTransitioning = true;
    this.cameras.main.flash(200);
    this.time.delayedCall(200, () => {
      this.cameras.main.fadeOut(1000, 0, 0, 0);
    });
    this.time.delayedCall(1300, () => {
      this.scene.start(SceneName.IntroCardScene);
    });
    this.cameras.main.zoomTo(1.1, 1500, `Sine.easeOut`);
  }

  create() {
    SoundPlayer.registerScene(this);
    sendStartEvent();
    this.isTransitioning = true;

    const authorText = this.add.text(
      64,
      24,
      `A game by\nAndrew Carwicz\nand\nNic Alabaster`,
      {
        fontFamily: "sins",
        fontSize: "16px",
        align: "center",
      }
    );
    SoundPlayer.switchSong(this, MusicOptions.stars);

    authorText.setOrigin(0.5);
    authorText.setResolution(10);

    const text = (this.text = this.add.text(64, 64, `Spacebar to Start`, {
      fontFamily: "sins",
      fontSize: "16px",
      align: "center",
    }));

    this.add.tween({
      targets: authorText,
      alpha: { from: 1, to: 0 },
      ease: `Sine.easeOut`,
      duration: 4000,
    });
    this.time.delayedCall(1200, () => {
      this.isTransitioning = false;
    });

    text.setOrigin(0.5);
    text.setResolution(10);

    this.add.sprite(0, 0, "atlas", "startingscene/backer").setDepth(-3);
    this.add.sprite(0, 0, "atlas", "startingscene/city").setDepth(-1);
    this.rikoText = this.add
      .sprite(0, 0, "atlas", "startingscene/title")
      .setDepth(-1.05);
    const tileSprite = (this.fog = this.add.tileSprite(
      64,
      64,
      128,
      128,
      "atlas",
      "startingscene/fog_hor_tile"
    ));
    const tileSprite2 = (this.fog2 = this.add.tileSprite(
      64,
      64,
      128,
      128,
      "atlas",
      "startingscene/fog_hor_tile2"
    ));
    const tileSprite3 = (this.fog3 = this.add.tileSprite(
      64,
      64,
      128,
      128,
      "atlas",
      "startingscene/fog_hor_tile3"
    ));

    new StarParticles(this);

    this.fog2.tilePositionX += 64;
    this.fog3.tilePositionX += 89;

    tileSprite.setBlendMode(Phaser.BlendModes.SCREEN);
    tileSprite2.setBlendMode(Phaser.BlendModes.SCREEN);
    tileSprite3.setBlendMode(Phaser.BlendModes.SCREEN);
    tileSprite.setDepth(-1.5);
    tileSprite2.setDepth(-1.4);
    tileSprite3.setDepth(-1.2);
    tileSprite.setTint(0x8a5591);
    tileSprite2.setTint(0x8a5591);
    tileSprite3.setTint(0x8a5591);
  }

  update(time: number, delta: number) {
    const blinkTime = time % 2000;
    if (!this.isTransitioning) {
      this.text.setVisible(blinkTime > 200);
    } else {
      this.text.setVisible(false);
    }

    this.fog.tilePositionX -= delta / 231;
    this.fog2.tilePositionX -= delta / 641;
    this.fog3.tilePositionX -= delta / 83;

    const turnBaseInput: TurnBasedInputPlugin = (this as any).myInput;
    if (turnBaseInput.isJustPressedAction) {
      this.transitionToMap();
    }
  }
}
